// =============================================
// theme.js - Chakra UI v3 Theme Configuration
//
// Migrated from v2 extendTheme to v3 createSystem + defineConfig.
// All token values wrapped in { value: ... }.
// Semantic tokens added for brand and accent colorPalette support.
// globalCss replaces styles.global.
//
// Last updated: 2026-06-10T00:00:00Z
// =============================================

import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: { value: "'Archivo Narrow', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif" },
        body: { value: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif" },
      },
      fontSizes: {
        heading: { value: 'lg' },
        text: { value: 'sm' },
        small: { value: 'xs' },
      },
      radii: {
        card: { value: '12px' },
        panel: { value: '10px' },
        input: { value: '8px' },
      },
      colors: {
        brand: {
          50: { value: '#f0f9ff' },
          100: { value: '#e0f2fe' },
          200: { value: '#bae6fd' },
          300: { value: '#7dd3fc' },
          400: { value: '#38bdf8' },
          500: { value: '#1e40af' },
          600: { value: '#1d4ed8' },
          700: { value: '#1e3a8a' },
          800: { value: '#1e40af' },
          900: { value: '#1e3a8a' },
        },
        accent: {
          50: { value: '#fffbeb' },
          100: { value: '#fef3c7' },
          200: { value: '#fde68a' },
          300: { value: '#fcd34d' },
          400: { value: '#fbbf24' },
          500: { value: '#f59e0b' },
          600: { value: '#d97706' },
          700: { value: '#b45309' },
          800: { value: '#92400e' },
          900: { value: '#78350f' },
        },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: '{colors.brand.500}' },
          contrast: { value: '{colors.brand.100}' },
          fg: { value: '{colors.brand.700}' },
          muted: { value: '{colors.brand.100}' },
          subtle: { value: '{colors.brand.200}' },
          emphasized: { value: '{colors.brand.300}' },
          focusRing: { value: '{colors.brand.500}' },
        },
        accent: {
          solid: { value: '{colors.accent.500}' },
          contrast: { value: '{colors.accent.100}' },
          fg: { value: '{colors.accent.700}' },
          muted: { value: '{colors.accent.100}' },
          subtle: { value: '{colors.accent.200}' },
          emphasized: { value: '{colors.accent.300}' },
          focusRing: { value: '{colors.accent.500}' },
        },
      },
    },
  },
  globalCss: {
    body: {
      bg: { _light: 'gray.50', _dark: 'gray.950' },
      color: { _light: 'gray.900', _dark: 'gray.100' },
      lineHeight: '1.6',
    },
    '*:focus-visible': {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'brand.500',
      outlineOffset: '2px',
    },
  },
});

const system = createSystem(defaultConfig, config);

export default system;
